module.exports = __webpack_public_path__ + "static/media/Torracat_gaussian2.31013e95.png";